import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconArrowWall2Down: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-outlined-radius-0-stroke-1-IconArrowWall2Down"><Path d="M7.25 14.75L12 19.5L16.75 14.75" stroke="currentColor" strokeLinecap="square"/><Path d="M12 3.5V18.75" stroke="currentColor" strokeLinecap="square"/><Path d="M4.5 20.5H19.5" stroke="currentColor" strokeLinecap="square"/></CentralIconBase>;
});

export default IconArrowWall2Down;
